import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '@fos/shared/contracts/identity';
import { normalizeText } from '../../lib/search';

/**
 * Podpowiedź polityki haseł w UI (docs/API_AUTH.md: 12–128 znaków, bez emaila i imienia, bez popularnych haseł).
 * To tylko pomoc: pełną politykę (w tym listę popularnych haseł) sprawdza serwer.
 */
export interface PolicyCheck {
  id: 'length' | 'personal' | 'match';
  label: string;
  ok: boolean;
}

export function passwordChecks(
  password: string,
  context: { email?: string | null; name?: string | null; confirm?: string } = {},
): PolicyCheck[] {
  const checks: PolicyCheck[] = [
    {
      id: 'length',
      label: `Co najmniej ${PASSWORD_MIN_LENGTH} znaków`,
      ok: password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH,
    },
  ];
  const personal = personalParts(context.email, context.name);
  if (personal.length > 0) {
    const normalized = normalizeText(password);
    checks.push({
      id: 'personal',
      label: 'Bez Twojego emaila i imienia',
      ok: password.length > 0 && !personal.some((part) => normalized.includes(part)),
    });
  }
  if (context.confirm !== undefined) {
    checks.push({
      id: 'match',
      label: 'Oba hasła są takie same',
      ok: password.length > 0 && password === context.confirm,
    });
  }
  return checks;
}

function personalParts(email?: string | null, name?: string | null): string[] {
  const parts: string[] = [];
  const local = email?.split('@')[0];
  if (local && local.length >= 3) parts.push(normalizeText(local));
  for (const word of (name ?? '').split(/\s+/)) {
    if (word.length >= 3) parts.push(normalizeText(word));
  }
  return parts;
}

/** Pierwszy niespełniony warunek jako komunikat błędu (przy wysyłce formularza). */
export function passwordProblem(checks: PolicyCheck[], password: string): string | null {
  if (!password) return 'Podaj nowe hasło';
  if (password.length > PASSWORD_MAX_LENGTH) return `Hasło może mieć najwyżej ${PASSWORD_MAX_LENGTH} znaków`;
  const failed = checks.find((c) => !c.ok);
  if (!failed) return null;
  if (failed.id === 'length') return `Hasło musi mieć co najmniej ${PASSWORD_MIN_LENGTH} znaków`;
  if (failed.id === 'personal') return 'Hasło nie może zawierać Twojego emaila ani imienia';
  return 'Hasła się różnią';
}
